module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm._isColmo + 'icon-button',
    staticClass: ["dof-icon-button"]
  }, [_c('div', {
    staticClass: ["content"]
  }, [(_vm.isShowTriangle) ? _c('div', {
    staticClass: ["triangle"]
  }, [_c('div', {
    staticClass: ["triangle-mask"],
    style: _vm.maskStyle
  })]) : _vm._e(), _c('div', {
    staticClass: ["imgBox"],
    style: _vm.style,
    on: {
      "click": _vm.onClick
    }
  }, [(!_vm.isLoading && !_vm._iconFont.code) ? _c('image', {
    class: ['dof-icon-button-img', _vm.round && 'dof-icon-button-img--round'],
    style: _vm.imgStyle,
    attrs: {
      "src": _vm.src
    }
  }) : (!_vm.isLoading && _vm._iconFont.code) ? _c('dof-iconfont', {
    attrs: {
      "code": _vm._iconFont.code,
      "size": _vm.imgSize - 10,
      "color": _vm._iconFont.color
    },
    on: {
      "dofIconFontClicked": _vm.onClick
    }
  }) : _c('dof-spinner', {
    class: ['dof-icon-button-loading'],
    style: _vm.loadingImgStyle,
    attrs: {
      "type": _vm.loadingSrc
    }
  })], 1)]), _vm._t("default", [(_vm.text) ? _c('text', {
    staticClass: ["dof-icon-button-text"],
    style: {
      color: _vm._textColor
    }
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-219e6f63!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-icon-button/index.vue
// module id = 591
// module chunks = 0 1